var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 58",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7143 27.4286C29.7143 28.6709 28.6709 29.7143 27.4286 29.7143L4.49714 29.752C3.25486 29.752 2.248 28.7451 2.248 27.5029L2.28571 4.57143C2.28571 3.32914 3.32914 2.28572 4.57143 2.28572H17.1429V1.66893e-06H4.57143C2.088 1.66893e-06 0 2.53829 0 5.02172V27.5029C0 29.9863 2.01371 32 4.49714 32H26.9783C29.4617 32 32 29.912 32 27.4286V14.8571H29.7143V27.4286ZM30.8332 1.96649e-06H22.8572C22.2092 0.00114482 21.7155 0.524573 21.7143 1.14286C21.7132 1.76114 22.2092 2.28686 22.8572 2.28572L27.8801 2.24914L10.6378 18.6937C10.1806 19.1291 10.1806 19.8343 10.6378 20.2697C11.0926 20.7051 11.8332 20.7051 12.2892 20.2697L29.6812 3.68229L29.7143 9.14286C29.7132 9.76114 30.2092 10.2869 30.8572 10.2857C31.5052 10.2846 31.9989 9.76114 32.0001 9.14286V1.11429C32.0012 0.496002 31.4812 -0.00114089 30.8332 1.96649e-06Z",
    fill: "#406CB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.742816581852af83902a039c61995adc.svg";
export { ForwardRef as ReactComponent };